var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompPartner({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F2F5F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 30C10 27.8783 10.8429 25.8434 12.3431 24.3431C13.8434 22.8429 15.8783 22 18 22C20.1217 22 22.1566 22.8429 23.6569 24.3431C25.1571 25.8434 26 27.8783 26 30H24C24 28.4087 23.3679 26.8826 22.2426 25.7574C21.1174 24.6321 19.5913 24 18 24C16.4087 24 14.8826 24.6321 13.7574 25.7574C12.6321 26.8826 12 28.4087 12 30H10ZM18 21C14.685 21 12 18.315 12 15C12 11.685 14.685 9 18 9C21.315 9 24 11.685 24 15C24 18.315 21.315 21 18 21ZM18 19C20.21 19 22 17.21 22 15C22 12.79 20.21 11 18 11C15.79 11 14 12.79 14 15C14 17.21 15.79 19 18 19ZM26.284 22.703C27.6893 23.3359 28.882 24.3612 29.7186 25.6557C30.5552 26.9502 31.0002 28.4587 31 30H29C29.0002 28.844 28.6666 27.7125 28.0391 26.7416C27.4116 25.7707 26.5171 25.0017 25.463 24.527L26.283 22.703H26.284ZM25.596 11.413C26.6035 11.8283 27.465 12.5335 28.071 13.4392C28.6771 14.3449 29.0004 15.4102 29 16.5C29.0004 17.8723 28.4877 19.1952 27.5625 20.2088C26.6374 21.2224 25.3667 21.8535 24 21.978V19.965C24.7409 19.8589 25.4283 19.518 25.9613 18.9925C26.4943 18.4669 26.8447 17.7843 26.9612 17.0449C27.0776 16.3055 26.954 15.5483 26.6084 14.8844C26.2628 14.2204 25.7134 13.6847 25.041 13.356L25.596 11.413Z",
    fill: "#4778F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompPartner);
export default __webpack_public_path__ + "static/media/compPartner.11324892f8b37f15edf1dc56558b3551.svg";
export { ForwardRef as ReactComponent };